var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flight-bags"},[_c('content-section',[[_c('flight-pad-details-bags',{attrs:{"flight_offer":_vm.flight_offer,"title":_vm.title,"description":_vm.description}})]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }